import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { SendOrderStatusAnalyticDataEvent } from '@pages/order-status/store/order-status-analytics.actions';
import { GoToSection } from '@shared/navigation/store/navigation.actions';

@Component({
    selector: 'order-status-my-account-btn',
    templateUrl: './order-status-my-account-btn.component.html',
})
export class OrderStatusMyAccountBtnComponent {
    constructor(
        private readonly store: Store,
    ) {}

    public goMyOrders() {
        this.store.dispatch(GoToSection({ url: 'orderStatus' }));
        this.store.dispatch(SendOrderStatusAnalyticDataEvent({ actionType: 'ver_mis_pedidos' }));
    }
}
